export default {
  authentication: true,
  localhost: "/kapi",
  project: "ai",
  // localhost: "http://https://gemini.medflying.com",
  host: "https://gemini.medflying.com",//正式服记得改
  urlPrefix: "/api", // 正式服记得改
  pageName: "飞派AI创造工作台",// 正式服记得改
  mobileWidth: 500,//移动端屏幕宽
  tips: {
    axiosSuccess: {
      update: '修改成功',
      create: '新增成功',
      delete: '删除成功',
      import: '导入成功',
      export: '导出成功'
    },
    axiosError: {
      400: '参数错误',
      403: '权限受限，请联系管理员',
      404: '请求链接不存在，请联系管理员',
      405: '请求方式不正确，应为POST/GET',
      500: '服务器错误，请联系管理员',
      default: '无效的请求，状态码（$），请联系管理员',
      other: '未知错误，请联系管理排查'
    }
  },
  label: {
    table: {
      select: '查询',
      create: '新增',
      modify: '修改',
      export: '导出',
      import: '导入',
      delete: '删除',
      audit: '审核',
      detail: '详情',
      preview: '预览'
    }
  },
  defaults: {
    search: {
      page: 1,
      pagesize: 20
    }
  },
  types: {
    exports: {
      zip: 'application/zip',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    },
    files: {
      attachment: "erp_project_attachment"
    },
    have_contract: [
      { label: "有", value: 1 },
      { label: "无", value: 0 }
    ],
    contractType: [
      {
        label: "开口合同",
        value: 1,
      },
      {
        label: "闭口合同",
        value: 0,
      },
    ],
    cancelStatusTips: {
      1: "申请撤销审批中",
      2: "该申请已撤销",
    },
    operationStatus: ["进行中", "已完结", "已驳回", "已撤销"],
    auditResult: ["未审核", "通过", "驳回"],
    cancelAuditResult: ["未申请", "申请中", "申请通过", "申请驳回"],
    auditExecutorResult: ["未审核", "已同意", "已拒绝"],
    disabledStatus: ["否", "是"],
    userLevel: ["超级管理员", "领导", "普通"],
    projectType: ["无营收", "有营收"],
    // projectDemandType:["平台综合类", "医学物料类","美化或视频类","项目执行类"],//项目需求类型
    projectDemandType: ["1.线上会议（含飞派，研讨会定制模式）", "2.医学物料定制", "3.仅设计或美化需求", "4.项目执行（1除外）", "5.IT开发定制", "6.医学研究类"],//项目需求类型
    subTaskType: {
      0: ["无制作类型"],
      1: ["幻灯制作", "幻灯更新", "推文/图文制作", "推文/图文更新", "DA/手册制作", "DA/手册更新", "文献类"],
      2: ["创意视频制作", "创意视频更新", "幻灯美化"],
      3: ["会议执行", "物料审核"]
    },//需求类型对应的制作类型
    invoiceType: ["普通发票", "增值税专用发票"],
    mailType: ["是", "否,电子版即可"],
    status: ["是", "否"],
    taskType: ["医学物料", "项目执行及美化协助", "大型项目或开发需求"],
  },
  toolbarConfig: {
    toolbarKeys: [
      // 菜单 key
      // 'headerSelect',
      // // 分割线
      'color',
      "underline",
      "numberedList",
      // "indent",
      // "delIndent"
      {
        "key": "group-indent",
        "title": "缩进",
        "menuKeys": [
          "indent",
          "delIndent"
        ]
      },
      '|',
      "fontSize",
      "fontFamily"
    ],
  }
}